import { TableSkeleton } from '@/_components';
import { CardContainer, SectionHeadingSkeleton } from '@/_containers';

export default function Loading() {
  return (
    <CardContainer>
      <SectionHeadingSkeleton />
      <div className="mt-6">
        <TableSkeleton numberOfColumns={8} maxRows={4} containerClassName="border-0" />
      </div>
    </CardContainer>
  );
}
